var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSjonvarp = function SvgSjonvarp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sjonvarp_svg__a)",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 17.997a.5.5 0 1 1 0-1M10.25 17.997a.5.5 0 1 0 0-1M10.25 23.997a.5.5 0 1 1 0-1M10.25 23.997a.5.5 0 1 0 0-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.25 3.83a12.721 12.721 0 0 0-16 0M5.583 7.301a7.423 7.423 0 0 1 9.333 0M12.75 31h-5a4 4 0 0 1-4-4V15a4 4 0 0 1 4-4h5a4 4 0 0 1 4 4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.75 20-2.231-1.673a2.09 2.09 0 0 0-2.995.513 2.087 2.087 0 0 0 0 2.32l2.192 3.29a6 6 0 0 0 2.764 2.242L23.75 28v3M19.012 12.684l5.532 2.37a6 6 0 0 1 3.152 3.153l1.57 3.66c.32.747.485 1.55.485 2.364V31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sjonvarp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgSjonvarp;